import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  hashHistory
} from 'react-router';
import { Toast } from 'antd-mobile/lib';
import { getEfficientQuestionnaire, addUserAnswerByZt, getRcommendStrategy } from "../../action/investmentAction.js";
import { traceSave } from "../../action/riskInPayAction.js";

let ua=navigator.userAgent.toLowerCase()

class MakePlanDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
     ageVal: "",
     typeListArr: [],
     // radioFlag: "1",
     certAge: "",
     riskModal: false,  //风险提示
     riskMakeFlag: false, // 重新规划
     nothingFlag: false, // 重新规划
     // radioContent: "",
     // radioAnswer: [],
     ageContent: "",
     typeListContent: "",
     questionnaireId: "",
     allStrategyList: [],
     partMateStrategyList: [],
     textByAge: "",
     modalXai: false,
     showText: false,
     sceneVoList: []
    };
  }
  componentWillMount() {
   
  }
  componentWillUnmount(){

  }
  componentDidMount() {
    this.getQuestionFun();
  }
  chooseDataFun = (arr) => {
    let _count = false;
    if(arr && arr.length > 0) {
      for(let i = 0; i < arr.length; i++) {
        if(arr[i].superFundProductViewList && arr[i].superFundProductViewList.length > 0) {
          _count = true;
          break;
        }
      }
    }
    return _count;
  }
  chooseDataSecFun = (arr) => {
    if((arr && arr.length === 0) || !arr) {
      return true;
    }else {
      let _count = true;
      if(arr && arr.length > 0) {
        for(let i = 0; i < arr.length; i++) {
          if(arr[i].superFundProductViewList && arr[i].superFundProductViewList.length > 0) {
            _count = false;
            break;
          }
        }
      }
      return _count;
    }
  }
  //获取题目
  getQuestionFun = () => {
    this.props.dispatch(getEfficientQuestionnaire({}, (res) => {
      console.log(res);
      this.setState({
        questionnaireId: res.content.questionnaireId
      });
      if(res.content.questionList && res.content.questionList.length > 0) {
        let dataSource = [].concat(res.content.questionList);
        for(let i = 0; i < dataSource.length; i++) {
          if(dataSource[i].order == "1") {
            this.setState({
              ageContent: dataSource[i].content
            });
          }
          if(dataSource[i].order == "2") {
            const _arr = [];
            for(let s = 0; s < dataSource[i].optionList.length; s++) {
              if(dataSource[i].optionList[s].order > 0) {
                _arr[Number(dataSource[i].optionList[s].order) - 1] = {
                  flag: false,
                  title: dataSource[i].optionList[s].content.split("：")[0] + "：",
                  content: dataSource[i].optionList[s].content.split("：")[1],
                  order: dataSource[i].optionList[s].order
                }
              }
            }
            this.setState({
              typeListContent: dataSource[i].content,
              typeListArr: _arr
            }, () => {
              this.initYear();
            });
          }
          // if(dataSource[i].order == "3") {
          //   const _arr = [];
          //   for(let s = 0; s < dataSource[i].optionList.length; s++) {
          //     if(dataSource[i].optionList[s].order > 0) {
          //       _arr[Number(dataSource[i].optionList[s].order) - 1] = {
          //         content: dataSource[i].optionList[s].content,
          //         order: dataSource[i].optionList[s].order
          //       }
          //     }
          //   }
          //   this.setState({
          //     radioContent: dataSource[i].content,
          //     radioAnswer: _arr
          //   });
          // }
        }
      }
    }));
  }
  //初始化年份
  initYear = () => {
    if(this.props.location && this.props.location.state && this.props.location.state.certNo) {
      const _fullYear = new Date().getFullYear();
      const _certNo = this.props.location.state.certNo;
      const _ageVal = _fullYear - _certNo.toString().substr(6, 4);
      if(_ageVal > 0) {
        this.setState({
          certAge: _ageVal,
          ageVal: _ageVal
        });
      }
      this.changePlan(_ageVal);
    }
  }
  goBackFun = () => {
    hashHistory.goBack();
  }
  blurAgeFun = (e) => {
    const _val = e.target.value;
    this.changePlan(_val);
    if(_val) {
      if(this.state.certAge != _val && this.state.certAge !== "") {
        this.setState({
          showText: true
        });
      }else {
        this.setState({
          showText: false
        });
      }
    }else {
      this.changeChoose([false, false, false, false]);
      this.setState({
        showText: false
      });
    }
  }
  changeAge = (e) => {
    const _val = e.target.value;
    if(_val !== "") {
      const reg = new RegExp(/^\d{1,3}$/).test(_val);
      if(!reg) {
        // this.changeChoose([false, false, false, false]);
        let toast = Toast.info('请输入有效年龄', 2);
        return;
      }else {
        if(_val.toString().substr(0, 1) === "0" || _val.toString().substr(0, 1) === 0) {
          // this.changeChoose([false, false, false, false]);
          let toast = Toast.info('请输入有效年龄', 2);
          return;
        }else {
          this.setState({
            ageVal: _val
          });
          // this.changePlan(_val);
        }
      }
    }else {
      // this.changeChoose([false, false, false, false]);
      this.setState({
        ageVal: _val
      });
    }
    this.blurAgeFun(e);
  }
  selectFunByType = (index) => {
    const _arr = [].concat(this.state.typeListArr);
    _arr[index].flag = _arr[index].flag ? false : true;
    this.setState({
      typeListArr: _arr
    });
  }
  // chooseThis = (val) => {
  //   this.setState({
  //     radioFlag: val
  //   });
  // }
  showFundFun = () => {
    sessionStorage.setItem('loadSourceByZt', "true");
    setTimeout(() => {
      hashHistory.goBack();
    });
  }
  //根据年龄改变选项
  changePlan = (age) => {
    if(age === "" || age === undefined || age === null) {
      this.changeChoose([false, false, false, false]);
      this.setState({
        textByAge: ""
      });
    }else {
      let _age = age;
      _age = Number(_age);
      const _fullYear = new Date().getFullYear();
      const outYear = _fullYear - _age;
      switch(true) {
        case _age < 20:
          this.changeChoose([false, false, false, false]);
          this.setState({
            textByAge: ""
          });
          break;
        case outYear >= 1990:
          this.changeChoose([true, true, true, true]);
          this.setState({
            textByAge: "您当前正处在人生的快速上升期，此阶段可重点从财富积累视角出发，拉长您的资金投资期限，建议积极参与权益类投资品种。"
          });
          break;
        case outYear >= 1980 && outYear < 1990:
          this.changeChoose([true, true, true, true]);
          this.setState({
            textByAge: "您当前正处在人生的黄金期，此阶段可重点从家庭整体场景需求的视角出发，开始为子女储备教育金，为自己及家人储备养老金，建议积极参与权益类投资品种。"
          });
          break;
        case outYear >= 1970 && outYear < 1980:
          this.changeChoose([true, true, true, true]);
          this.setState({
            textByAge: "您当前正处在人生的稳定期，此阶段可重点从家庭整体场景需求的视角出发，开始为子女储备教育金，为自己及家人储备养老金，建议均衡配置权益类和稳健类投资品种。"
          });
          break;
        case outYear >= 1960 && outYear < 1970:
          this.changeChoose([true, true, true, false]);
          this.setState({
            textByAge: "您当前即将步入或已经进入退休期，此阶段可重点从退休后的资金需求视角出发，为自己及家人储备充备的养老金，建议逐渐降低权益类投资品种的比例。"
          });
          break;
        case outYear < 1960:
          this.changeChoose([true, true, false, false]);
          this.setState({
            textByAge: "您当前已经进入退休养老阶段，此阶段可重点从退休后的生活开支需求视角出发，力求自己的养老金保值增值，建议积极参与稳健类投资品种。"
          });
          break;
      }
    }
  }
  changeChoose = (data) => {
    const _arr = [].concat(this.state.typeListArr);
    for(let i = 0; i < _arr.length; i++) {
      _arr[i].flag = data[i];
    }
    this.setState({
      typeListArr: _arr
    });
  }
  sucAnswer = () => {
    Toast.loading();
    this.setState({
      allStrategyList: [],
      partMateStrategyList: []
    });
    if(!this.state.ageVal) {
      let toast = Toast.info('年龄不能为空', 2);
      return;
    }
    let answerSec = "";
    for(let i = 0; i < this.state.typeListArr.length; i++) {
      if(this.state.typeListArr[i].flag) {
        answerSec = answerSec + this.state.typeListArr[i].order;
      }
    }
    if(!answerSec) {
      let toast = Toast.info('请至少选择一项', 2);
      return;
    }
    // const addAnswerList = [{
    //   questionNo: "1",
    //   answer: (new Date().getFullYear() - this.state.ageVal).toString()
    // }, {
    //   questionNo: "2",
    //   answer: answerSec
    // }, {
    //   questionNo: "3",
    //   answer: this.state.radioFlag
    // }];
    const addAnswerList = [{
      questionNo: "1",
      answer: (new Date().getFullYear() - this.state.ageVal).toString()
    }, {
      questionNo: "2",
      answer: answerSec
    }];
    this.props.dispatch(addUserAnswerByZt({
      questionnaireId: this.state.questionnaireId,
      addAnswerList: addAnswerList
    }, (res) => {
      console.log(res);
      if(res && res.content === true) {
        this.props.dispatch(getRcommendStrategy({}, (suc) => {
          console.log(suc);
          if(suc && suc.content) {
            Toast.hide();
            this.setState({
              sceneVoList: suc.content.sceneVoList
            }, () => {
              if(suc.content.mateAll === true) {
                if(this.chooseDataSecFun(suc.content.allStrategyList)) {
                  this.setState({
                    nothingFlag: true
                  });
                }else {
                  //匹配直接跳转
                  this.showAllFundList(false, suc.content.allStrategyList ? suc.content.allStrategyList : [], "全部");
                }
              }else {
                //不匹配 一个也没有
                if(this.chooseDataSecFun(suc.content.allStrategyList)) {
                  this.setState({
                    nothingFlag: true
                  });
                }else {
                  this.setState({
                    riskModal: true,
                    allStrategyList: suc.content.allStrategyList ? suc.content.allStrategyList : [],
                    partMateStrategyList: suc.content.partMateStrategyList ? suc.content.partMateStrategyList : []
                  });
                }
              }
            });
          }else {
            Toast.hide();
          }
        }));
      }else {
        Toast.hide();
      }
    }));
  }
  showRiskMakeFun = () => {
    this.props.dispatch(traceSave({action: 'SF_SPECIAL_TIP', message: '用户查看部分智投产品时间: ' + new Date().toLocaleString()}));
    if(this.chooseDataSecFun(this.state.partMateStrategyList)) {
      this.setState({
        riskModal: false,
        riskMakeFlag: true
      });
    }else {
      this.showAllFundList(true, this.state.partMateStrategyList, "部分");
    }
  }
  showAllFundList = (flag, data, name) => {
    this.props.dispatch(traceSave({action: 'SF_SPECIAL_TIP', message: '用户查看全部智投产品时间: ' + new Date().toLocaleString()}));
    if(flag === true) {
      this.setState({
        riskModal: false
      });
    }
    if(this.chooseDataFun(data)) {
      const tabListArr = [];
      for(let i = 0; i < this.state.sceneVoList.length; i++) {
        let _count = 0;
        let _countSec = 0;
        for(let s = 0; s < data.length; s++) {
          if(data[s].superFundProductViewList && data[s].superFundProductViewList.length > 0) {
            _countSec = _countSec - 0 + 1;
            if(this.state.sceneVoList[i].sceneId != data[s].sceneId) {
              _count = _count - 0 + 1;
            }
          }
        }
        if(_count == _countSec && _count > 0) {
          tabListArr.push(this.state.sceneVoList[i].sceneName);
        }
      }
      console.log(tabListArr);
      hashHistory.push({
        pathname:'/MakePlanResult',
        state: {
          fundListArr: data,
          tabListArr: tabListArr,
          lookFlag: name,
          rootPath: "MakePlanDetail"
        }
      });
    }
  }
  resetData = () => {
    this.setState({
     ageVal: "",
     // radioFlag: "1",
     certAge: "",
     riskModal: false,  
     riskMakeFlag: false, 
     nothingFlag: false,
     allStrategyList: [],
     partMateStrategyList: [],
     textByAge: ""
    });
    const _arr = [].concat(this.state.typeListArr);
    for(let i = 0; i < _arr.length; i++) {
      _arr[i].flag = false;
    }
    this.setState({
      typeListArr: _arr
    }, () => {
      this.initYear();
    });
  }
  showModalXiaoai = () => {
    this.setState({
      modalXai: true
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "hidden";
    obj.addEventListener("touchmove", this.touchMove, false);
  }
  closeModalXai = () => {
    this.setState({
      modalXai: false
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "auto";
    obj.removeEventListener("touchmove", this.touchMove, false);
  }
  render() {
    return (
      <div style={{display: "-webkit-flex", WebkitFlex:1, backgroundColor: "#fff", WebkitFlexDirection: "column", WebkitAlignItems: "center", paddingBottom: 50}}>
        <div style={{backgroundImage: `url(${require("../../imgs/FinancialPlanning_bg.png")})`, backgroundSize: "cover", width: window.winWidth, height: window.winWidth / (1125 / 1113),paddingRight:20,paddingLeft:20 }}>
          {
            ua.indexOf("amcfmapp")>-1 ?
            null
            :
            <div style={{paddingTop: 20}}>
              <img onClick={this.goBackFun} src={require("../../imgs/eq_leftArrow1.png")} style={{width: 24, height: 24}} />
            </div>
          }
          <div style={{paddingTop: 20, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between", display: "-webkit-flex"}}>
            <p style={{fontSize: 24, color: "#fff", fontWeight: 500}}>华夏查理智投</p>
            <div style={{WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex"}}>
              <p style={{fontSize: 16, color: "#fff", fontWeight: 500}}>懂投资·更懂你</p>
              <img onClick={this.showModalXiaoai} src={require("../../imgs/icon_gth.png")} style={{width: 18, height: 18, marginLeft: 5}} />
            </div>
          </div>
        </div>
        <div style={{backgroundColor: "#fff", borderRadius: 4, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", paddingTop: 20, paddingBottom: 20, paddingLeft: 15, paddingRight: 15, width: window.winWidth - 40, marginTop: ua.indexOf("amcfmapp")>-1 ? -309 : -235}}>
          <div>
            <p style={{fontSize: 16, color: "#333", fontWeight: 500}}>{this.state.ageContent}</p>
          </div>
          <div style= {{marginTop: 10, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", width: window.winWidth - 70, position: "relative"}}>
            <input autoComplete="off" style={{paddingLeft: 10, width: window.winWidth - 70, height: 40, backgroundColor: "#FAFAFA", borderRadius: 4, color: "#666", fontSize: 18, paddingRight: 30}} onChange={(e) => {this.changeAge(e)}} onBlur={() => {}} type="text" value={this.state.ageVal} placeholder={'请输入年龄'} />
            <span style={{fontSize: 18, color: "#333", position: "absolute", right: 10}}>岁</span>
          </div>
          {
            this.state.showText ?
            <div style={{marginTop: 10}}>
              <p style={{fontSize: 13, color: "#F92C3D", fontWeight: 500}}>您填写的年龄与您开户填写的信息不符</p>
            </div>
            :
            null
          }
          <div style={{marginTop: 25}}>
            <p style={{fontSize: 16, color: "#333", fontWeight: 500}}>{this.state.typeListContent}</p>
          </div>
          <div style={{marginTop: 10}}>
            <p style={{fontSize: 12, lineHeight: "17px", color: "#666"}}>{this.state.textByAge}</p>
            <p style={{fontSize: 12, lineHeight: "17px", color: "#F92C3D"}}>{this.state.textByAge === "" ? null : "预测您有如下需求，您也可自行调整。"}</p>
          </div>
          <div>
            {
              this.state.typeListArr.map((data, index) => {
                if(data.flag) {
                  return (
                    <div onClick={() => {this.selectFunByType(index)}} key={index} style={{position: "relative", borderRadius: 2, marginTop: index === 0 ? 10 : 8, width: window.winWidth - 70, display: "-webkit-flex", WebkitFlexDirection: "column", paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFEEF0", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", paddingTop: 7, paddingBottom: 7}}>
                      <p style={{fontSize: 12, color: "#F92C3D", fontWeight: 500, whiteSpace: "pre"}}>{data.title}</p>
                      <p style={{fontSize: 11, color: "#F92C3D", lineHeight: "17px", marginTop: 2}}>{data.content}</p>
                      <img src={require("../../imgs/st_icon.png")} style={{width: 8, height: 8, position: "absolute", right: 0, top: 0}} />
                    </div>
                  )
                }else {
                  return (
                    <div onClick={() => {this.selectFunByType(index)}} key={index} style={{position: "relative", borderRadius: 2, marginTop: index === 0 ? 10 : 8, width: window.winWidth - 70, display: "-webkit-flex", WebkitFlexDirection: "column", paddingLeft: 10, paddingRight: 10, backgroundColor: "#F5F5F5", borderStyle: "solid", borderWidth: 1, borderColor: "#F5F5F5", paddingTop: 7, paddingBottom: 7}}>
                      <p style={{fontSize: 12, color: "#666", fontWeight: 500, whiteSpace: "pre"}}>{data.title}</p>
                      <p style={{fontSize: 11, color: "#666", lineHeight: "17px", marginTop: 2}}>{data.content}</p>
                    </div>
                  )
                }
              })
            }
          </div>
          {/*<div>
            <div style={{marginTop: 25}}>
              <p style={{fontSize: 16, color: "#333", fontWeight: 500}}>{this.state.radioContent}</p>
            </div>
            <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingTop: 18}}>
              {
                this.state.radioAnswer.map((data, index) => {
                  return (
                    <div key={index} onClick={() => {this.chooseThis(data.order)}} style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: index === 0 ? 0 : 10}}>
                      {
                        this.state.radioFlag == data.order ?
                        <div style={{width: 14, height: 14, borderRadius: 14,backgroundColor: "#F92C3D", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                          <div style={{width: 6, height: 6, borderRadius: 6,backgroundColor: "#fff"}}>
                          
                          </div>
                        </div>
                        :
                        <div style={{width: 14, height: 14, borderColor: "#CFCFCF", borderStyle: "solid", borderWidth: 0.5, borderRadius: 14,backgroundColor: "transparent"}}>
                        
                        </div>
                      }
                      <p style={{fontSize: 14, color: "#333", marginLeft: 5}}>{data.content}</p>
                    </div>
                  )
                })
              }
            </div>
            {
              this.state.radioAnswer.length > 0 && this.state.radioFlag == "1" ?
              <div style={{marginTop: 18}}>
                <p style={{fontSize: 12, color: "#666", lineHeight: "17px"}}>我们将为您优选未出-5年具有投资价值的行业赛道投顾产品(例如：科技、新能源、消费等)，如您无行业投资偏好，可选为否。</p>
              </div>
              :
              null
            }
          </div>*/}
          <div style={{width: window.winWidth - 70, display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center", marginTop: 30}}>
            <div onClick={this.sucAnswer} style={{width: 122, height: 32, backgroundColor: "#F92C3D", borderRadius: 4, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <p style={{fontSize: 14, color: "#fff"}}>为我规划</p>
            </div>
          </div>
        </div>
        <div onClick={this.showFundFun} style={{boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", width: window.winWidth - 40, height: 50, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#fff", WebkitFlexDirection: "row", borderRadius: 4, marginTop: 20}}>
          <p style={{fontSize: 14, color: "#2C3245"}}>我有明确投资目标，希望直接挑选组合</p>
          <img src={require("../../imgs/xiaoicon_shuoming.png")} style={{width: 16, height: 16, marginLeft: 5}} />
        </div>
        {/*风险提示*/}
        {
          this.state.riskModal ?
          <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
            <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
              <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
              </div>
              <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>为您规划的方案中部分产品的风险等级与您的风险承受能力不符，请确认是否全部查看</p>
              </div>
              <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                <div onClick={this.showRiskMakeFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                  <p style={{fontSize: 14, color: "#F92C3D"}}>部分查看</p>
                </div>
                <div onClick={() => {this.showAllFundList(true, this.state.allStrategyList, "全部")}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                  <p style={{fontSize: 14, color: "#fff"}}>全部查看</p>
                </div>
              </div>
            </div>
          </div>
          :
          null
        }
        {/*重新规划*/}
        {
          this.state.riskMakeFlag ?
          <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
            <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
              <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
              </div>
              <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>尊敬的用户，您选择了部分查看，已为您屏蔽掉风险不匹配的组合策略，屏蔽后，暂无匹配您风险需求的投顾组合。</p>
              </div>
              <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                <div onClick={this.resetData} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                  <p style={{fontSize: 14, color: "#fff"}}>重新规划</p>
                </div>
              </div>
            </div>
          </div>
          :
          null
        }
        {/*重新规划*/}
        {
          this.state.nothingFlag ?
          <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
            <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
              <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>风险提示</p>
              </div>
              <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20}}>
                <p style={{fontSize: 14, color: "#333", lineHeight: "20px"}}>尊敬的用户，基于您的需求，暂未能为您匹配出投顾组合。</p>
              </div>
              <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                <div onClick={this.resetData} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                  <p style={{fontSize: 14, color: "#fff"}}>重新规划</p>
                </div>
              </div>
            </div>
          </div>
          :
          null
        }
        {
          this.state.modalXai ? 
          <div style={{width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex"}}>
            <div style={{WebkitFlexDirection: "column", width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center",  display: "-webkit-flex"}}>
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitFlexDirection: "column"}}>
                <span style={{fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20,fontWeight:"500"}}>{"华夏查理智投依托于华夏财富多年的投顾服务经验，基于您在不同人生阶段的财富目标，通过智能化的算法模型为您匹配定制化财富管理方案，一站式满足您的资产保值、财富成长、品质养老、子女教育等场景需求。"}</span>
                <span style={{fontSize: 16, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20,fontWeight:"500"}}>{"我们希望通过专业化、场景化的基金投顾服务，帮助您降低筛选基金的门槛，并通过全程暖心陪伴服务，帮助您坚定地长期持有，将优选基金的业绩转化为您的实际回报，让您在投资过程中更省心、更安心。"}</span>
                <div onClick={this.closeModalXai} style={{ width:"100%", height:"40px", textAlign:"center", lineHeight:"40px",borderTopColor:"#ebeef0",borderTopWidth:"1px",borderTopStyle:"solid",marginTop:"15px"}}>
                  <div style={{WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%"}}>
                    <span style={{fontSize:17,color:'#666666'}}>知道了</span>
                  </div>
                </div> 
              </div>
            </div>           
          </div> 
          : 
          null
        }
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    
  }
}

export default connect(mapStateToProps)(MakePlanDetail);


// WEBPACK FOOTER //
// ./src/components/fundDetail/MakePlanDetail.js